import React, { useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import { useRecoilValue } from 'recoil';

import { useTasks } from 'lib/hooks/queries/tasks/useTasks';

import { currentPractice } from 'components/practice/practiceState';
import AgTablePage from 'components/shared/AgTablePage/AgTablePage';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import state from 'components/state';

import ActionButtons from './components/ActionButtons';
import NewTask from './components/NewTask';
import PreviewTask from './components/PreviewTask';
import { DEFAULT_FILTERS, defaultColumns } from './lib/helpers';

const category = 'tasks';

const NewTaskModal = ({ isOpen, handleClose, item }) => {
  return item ? (
    <PreviewTask task={item} previewTaskModal hidePreviewTaskModal={handleClose} />
  ) : (
    <NewTask newTaskModal={isOpen} hideNewTaskModal={handleClose} />
  );
};

const Tasks = () => {
  const practice = useRecoilValue(currentPractice);
  const permissions = useRecoilValue(state.permissions);
  const { id: taskId } = useParams();

  const columnDefs = useMemo(
    () => defaultColumns(practice.timezone, permissions),
    [practice.timezone, permissions]
  );

  return (
    <>
      <AgTablePage
        ModalComponent={NewTaskModal}
        defaultColumns={columnDefs}
        defaultFilters={DEFAULT_FILTERS}
        useData={useTasks}
        name={category}
        rowStyle={{ cursor: 'pointer' }}
        actions={ActionButtons}
      />
      {taskId && <Outlet />}
    </>
  );
};

export default withErrorBoundary(Tasks);
